import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ListBaseComponent } from 'app/shared/components/base/list-base/list-base.component';
import { Constants } from 'app/shared/constants/constants';
import { Modals } from 'app/shared/constants/modals';
import { Permissions } from 'app/shared/constants/permissions';
import { Sections } from 'app/shared/constants/sections';
import { SmsMessage } from 'app/shared/models/sms-message.model';
import { SectionService } from 'app/shared/services/section.service';
import { SmsMessageService } from 'app/shared/services/sms-message.service';
import { PaginationService } from 'ngx-pagination';
import { SmsMessageFilter } from '../../../shared/filters/sms-message.filter';

@Component({
  selector: 'app-sms-messages-list',
  templateUrl: './sms-messages-list.component.html',
  styleUrls: ['./sms-messages-list.component.scss'],
  providers: [PaginationService],
  encapsulation: ViewEncapsulation.None
})
export class SmsMessagesListComponent extends ListBaseComponent implements OnInit {

  fieldCollection = [
    {
      name: 'SmsMessageId',
      displayName: 'smsMessages.smsMessageIdFieldTitle',
      canSort: true,
      displayClass: "d-none d-sm-table-cell"
    },
    {name: 'Sender', displayName: 'smsMessages.senderFieldTitle', canSort: true, displayClass: ""},
    {
      name: 'RecipientPhonenumber',
      displayName: 'smsMessages.recipientPhonenumberFieldTitle',
      canSort: true,
      displayClass: ""
    },
    {
      name: 'Status.IconClass',
      displayName: 'smsMessages.statusFieldTitle',
      canSort: false,
      displayClass: "d-none d-sm-table-cell"
    },
  ];

  smsMesssageFilter: SmsMessageFilter;
  smsMessageSendSuccessfully: string;

  get hasSendPermission(): boolean {
    return this.hasPermission(Permissions.SmsMessages_Send);
  }

  constructor(protected sectionService: SectionService, protected smsMessageService: SmsMessageService, protected modalService: NgbModal, protected translateService: TranslateService) {
    super(sectionService, Sections.SmsMessages, modalService, Modals.SendSmsMessageComponent);
  }

  ngOnInit() {
    this.smsMesssageFilter = new SmsMessageFilter();
    super.initializeView(Constants.SmsMessages_List_DefaultSortField, Constants.SmsMessages_List_DefaultSortDirectionAscending);
    this.translateService.get(['smsMessages.sendSuccessfullyMessage'])
      .subscribe(translations => {
        this.smsMessageSendSuccessfully = translations['smsMessages.sendSuccessfullyMessage'];
      });
  }

  searchFilter(event: any) {
    this.smsMesssageFilter.RecipientPhonenumber = event.target.value.toLowerCase();
    this.getCollection();
  }

  send(smsMessage: SmsMessage) {
    this.smsMessageService.sendSmsMessage(smsMessage, () => this.getCollection(), this.smsMessageSendSuccessfully);
  }

  getCollection(pageNumber: number = 1) {
    if (pageNumber) {
      this.pageConfiguration.PageNumber = pageNumber;
    }

    this.smsMessageService.getCollectionPaginated<SmsMessage>("/sms-message", this.pageConfiguration, this.smsMesssageFilter, (collection) => {
      this.collection = collection
    });
  }
}
